import React, { useState } from 'react';

import styles from './styles.module.css';
import SearchIcon from '@/assets/icons/search.svg?react';

interface SearchComponentProps {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  onSearchChange: (value: string) => void;
  placeholder?: string;
}

const SearchComponent: React.FC<SearchComponentProps> = ({
  icon: Icon,
  title,
  onSearchChange,
  placeholder = 'Search by name'
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearchChange(value);
  };

  return (
    <div className={styles.modalTitle}>
      <div className={styles.titleSection}>
        <Icon className={styles.titleIcon} />
        <span>{title}</span>
      </div>
      <div className={styles.searchContainer}>
        <SearchIcon className={styles.searchIcon} />
        <input
          type="text"
          placeholder={placeholder}
          value={searchTerm}
          onChange={handleSearchChange}
          className={styles.searchInput}
        />
      </div>
    </div>
  );
};

export default SearchComponent;
